/* ============================================================
   TOUNI RELOOK — comportements (banniers reveal/sweep, posters vidéo,
   bandeau réassurance). Chargé en defer. 100% additif, réversible.
   Marqueur : TOUNI-RELOOK
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) Bannières : apparition au scroll + reflet lumineux (sweep) */
  function initBanners() {
    var banners = document.querySelectorAll('.bee-banner .bee-banner-inner');
    if (!banners.length) return;
    banners.forEach(function (b) {
      if (b.classList.contains('tn-reveal')) return;
      b.classList.add('tn-reveal');
    });
    if (reduce || !('IntersectionObserver' in window)) {
      banners.forEach(function (b) { b.classList.add('tn-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('tn-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18 });
    banners.forEach(function (b) { io.observe(b); });
  }

  /* 2) Vidéos produit : poster de secours = image du produit (anti écran noir) */
  function initVideoPosters() {
    var vids = document.querySelectorAll('.trk .itm video, .cvc video');
    if (!vids.length) return;
    var poster = '';
    var og = document.querySelector('meta[property="og:image"]');
    if (og) poster = og.content;
    if (!poster) {
      var pimg = document.querySelector('.bee-product__media-item img, .bee-product-single__photo img, .bee-product__media img');
      if (pimg) poster = pimg.currentSrc || pimg.src || '';
    }
    if (!poster) return;
    vids.forEach(function (v) {
      if (!v.getAttribute('poster')) v.setAttribute('poster', poster);
    });
  }

  /* 3) Bandeau réassurance sous le bouton d'achat */
  function initTrustStrip() {
    if (document.querySelector('.tn-trust')) return;
    var form = document.querySelector('.bee-form__product');
    if (!form) return;
    var anchor = form.querySelector('.bee-product-form__buttons') ||
                 form.querySelector('.bee-pr__qty_cart') || null;
    var items = [
      ['<path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/>', 'Livraison 24-72h'],
      ['<path d="M3 7h18v10H3z"/><circle cx="12" cy="12" r="2.4"/><path d="M6 9.5v5M18 9.5v5"/>', 'Paiement à la livraison'],
      ['<path d="M21 11V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.15"/><path d="M3.3 7L12 12l8.7-5"/><path d="M12 22V12"/><path d="M15.5 18.5l2 2 4-4"/>', 'Ouvrez le colis avant de payer'],
      ['<path d="M4 8a8 8 0 0 1 14-3l2 2"/><path d="M20 4v4h-4"/><path d="M20 16a8 8 0 0 1-14 3l-2-2"/><path d="M4 20v-4h4"/>', 'Échange sous 48h']
    ];
    var html = '';
    items.forEach(function (it) {
      html += '<div class="tn-trust__i"><svg viewBox="0 0 24 24" aria-hidden="true">' + it[0] + '</svg><span>' + it[1] + '</span></div>';
    });
    var strip = document.createElement('div');
    strip.className = 'tn-trust';
    strip.innerHTML = html;
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(strip, anchor.nextSibling);
    else form.appendChild(strip);
  }

  /* 4) Barre d'achat collante (mobile) : apparaît quand le bouton principal sort de l'écran */
  function initStickyBar() {
    if (document.querySelector('.tn-sbar')) return;
    var atc = document.querySelector('.bee-product-form__submit');
    if (!atc) return;
    var titleEl = document.querySelector('.bee-product__title');
    var priceEl = document.querySelector('.bee-product__price-review .bee-product-price, .bee-product-price');
    var img = '';
    var og = document.querySelector('meta[property="og:image"]');
    if (og) img = og.content;
    if (!img) { var pi = document.querySelector('.bee-product__media-item img, .bee-product__media img'); if (pi) img = pi.currentSrc || pi.src || ''; }
    var title = titleEl ? titleEl.textContent.trim() : document.title;

    var bar = document.createElement('div');
    bar.className = 'tn-sbar';
    bar.innerHTML =
      '<div class="tn-sbar__info">' +
        (img ? '<img class="tn-sbar__img" src="' + img + '" alt="">' : '') +
        '<div class="tn-sbar__txt"><span class="tn-sbar__name"></span><span class="tn-sbar__price"></span></div>' +
      '</div>' +
      '<button type="button" class="tn-sbar__btn">Ajouter au panier</button>';
    bar.querySelector('.tn-sbar__name').textContent = title;
    if (priceEl) bar.querySelector('.tn-sbar__price').innerHTML = priceEl.innerHTML;
    document.body.appendChild(bar);

    bar.querySelector('.tn-sbar__btn').addEventListener('click', function () {
      try { atc.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
      atc.click();
    });

    /* Si une barre COD collante existe déjà (app es-sticky), s'empiler au-dessus */
    function placeAbove() {
      var cod = document.querySelector('.es-sticky-btn, .es-sticky');
      if (cod) {
        var r = cod.getBoundingClientRect();
        if (r.height > 10) bar.style.bottom = Math.round(r.height) + 'px';
        bar.classList.add('tn-sbar--stacked');
      } else {
        bar.style.bottom = '';
      }
    }
    placeAbove();
    window.addEventListener('resize', placeAbove);

    /* Remonter le bouton flottant Cadeau (#tm-btn) au-dessus de la barre quand elle s'affiche */
    var fab = document.getElementById('tm-btn');
    var fabBase = fab ? (parseInt(getComputedStyle(fab).bottom, 10) || 16) : 0;
    function moveFab(on) {
      if (!fab) return;
      if (on) {
        var stack = bar.getBoundingClientRect().height;
        var cod = document.querySelector('.es-sticky-btn, .es-sticky');
        if (cod) stack = bar.getBoundingClientRect().bottom - cod.getBoundingClientRect().top;
        fab.style.transition = 'bottom .3s cubic-bezier(.4,0,.2,1)';
        fab.style.bottom = (fabBase + Math.max(0, Math.round(stack)) + 10) + 'px';
      } else {
        fab.style.bottom = fabBase + 'px';
      }
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = e.boundingClientRect.top < 0 && !e.isIntersecting; // bouton au-dessus de l'écran
        if (past) placeAbove(); // la barre COD n'apparaît qu'au scroll : recalculer l'empilage
        bar.classList.toggle('tn-sbar--on', past);
        moveFab(past);
      });
    }, { threshold: 0 });
    io.observe(atc);
  }

  /* Barre d'achat sticky custom DÉSACTIVÉE : le thème a déjà sa barre COD (EasySell).
     Un 2e bar créait des chevauchements (COD, bouton Cadeau, footer). */
  /* 4) Carte magasin dark (Leaflet + tuiles sombres) : SEULEMENT le pin Touni.ma, aucun concurrent */
  function renderStoreMap(el) {
    if (!window.L || el.dataset.tnReady) return;
    el.dataset.tnReady = '1';
    var lat = parseFloat(el.dataset.lat), lng = parseFloat(el.dataset.lng);
    var link = el.dataset.link || '';
    var map = L.map(el, {
      zoomControl: false, dragging: false, scrollWheelZoom: false, doubleClickZoom: false,
      boxZoom: false, keyboard: false, touchZoom: false, tap: false
    }).setView([lat, lng], 16);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19, attribution: '&copy; OpenStreetMap'
    }).addTo(map);
    var icon = L.divIcon({ className: '', html: '<span class="tn-leaflet-pin"></span>', iconSize: [14, 14], iconAnchor: [7, 7] });
    var mk = L.marker([lat, lng], { icon: icon, interactive: false }).addTo(map);
    mk.bindTooltip('Touni.ma', { permanent: true, direction: 'top', offset: [0, -8], className: 'tn-leaflet-label' }).openTooltip();
    if (link) {
      el.style.cursor = 'pointer';
      el.addEventListener('click', function () { window.open(link, '_blank', 'noopener'); });
    }
    setTimeout(function () { map.invalidateSize(); }, 250);
  }
  function initStoreMap() {
    var el = document.getElementById('tn-footer-map');
    if (!el || el.dataset.tnInit) return;
    function load() {
      if (el.dataset.tnInit) return; el.dataset.tnInit = '1';
      if (window.L) { renderStoreMap(el); return; }
      var css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
      document.head.appendChild(css);
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
      s.onload = function () { renderStoreMap(el); };
      document.head.appendChild(s);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { load(); io.disconnect(); } });
      }, { rootMargin: '300px' });
      io.observe(el);
    } else { load(); }
  }

  /* Relook Futuriste v1 — reveal fluide des sections (titres, grilles, avis) */
  function initFutur() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets = [];
    function collect(sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el && !el.classList.contains('tn-rv') && !el.classList.contains('tn-in')) targets.push(el);
      });
    }
    collect('.bee-top-heading');
    /* .bee-products retiré du fondu (06/10) — grille + images produits affichées instantanément, zéro délai au scroll */
    collect('[id*="touni_avis"]');
    collect('.tn-sep');
    collect('.tn-stats');
    if (!targets.length) return;
    function reveal(el) { el.classList.add('tn-in'); }
    // reduced-motion / pas d'IO → tout affiché direct (jamais masqué)
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('tn-rv', 'tn-in'); });
      return;
    }
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
    targets.forEach(function (el) {
      // ⚠️ Déjà visible/presque à l'écran → affiché INSTANTANÉMENT (zéro page blanche).
      // Seul le contenu sous la ligne de flottaison garde le fondu au scroll.
      if (el.getBoundingClientRect().top < vh * 1.15) {
        el.classList.add('tn-rv', 'tn-in');
      } else {
        el.classList.add('tn-rv');
        io.observe(el);
      }
    });
    // garde-fou : ne jamais laisser une section cachée (secours rapide)
    setTimeout(function () {
      document.querySelectorAll('.tn-rv:not(.tn-in)').forEach(reveal);
    }, 1200);
  }

  /* Relook Futuriste v2 */
  function injectTicker() {
    if (document.querySelector('.tn-ticker')) return;
    var hero = document.querySelector('[id*="touni_hero"]');
    if (!hero) return;
    var words = ['Promotion exclusive', '3 achetés = le 4ᵉ offert', 'Paiement à la livraison', 'Ouvre le colis avant de payer'];
    var seg = words.map(function (w) { return '<span>' + w + '<em>✦</em></span>'; }).join('');
    var bar = document.createElement('div');
    bar.className = 'tn-ticker';
    bar.innerHTML = '<div class="tn-ticker__t">' + seg + seg + '</div>';
    hero.parentNode.insertBefore(bar, hero.nextSibling);
  }

  function injectSeparators() {
    var heads = document.querySelectorAll('.bee-top-heading');
    heads.forEach(function (h) {
      var sec = h.closest('.shopify-section') || h;
      var prev = sec.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('tn-sep')) return;
      var sep = document.createElement('div');
      sep.className = 'tn-sep';
      sec.parentNode.insertBefore(sep, sec);
    });
  }

  function injectStats() {
    if (document.querySelector('.tn-stats')) return;
    var footer = document.querySelector('[id*="touni-footer"], [id*="touni_footer"], .touni-footer');
    var anchor = footer || document.querySelector('footer');
    if (!anchor) return;
    var wrap = document.createElement('section');
    wrap.className = 'tn-stats';
    wrap.innerHTML =
      '<div class="tn-stats__in">' +
      '<div><div class="tn-stats__n" data-c="24" data-suf="-72h">24-72h</div><div class="tn-stats__l">Livraison partout au Maroc</div></div>' +
      '<div><div class="tn-stats__n" data-c="100" data-suf="%">100%</div><div class="tn-stats__l">Paiement à la livraison</div></div>' +
      '<div><div class="tn-stats__n" data-c="500" data-suf="+">500+</div><div class="tn-stats__l">Modèles disponibles</div></div>' +
      '<div><div class="tn-stats__n"><em>4.8</em>★</div><div class="tn-stats__l">Note clients</div></div>' +
      '</div>';
    anchor.parentNode.insertBefore(wrap, anchor);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nums = wrap.querySelectorAll('.tn-stats__n[data-c]');
    function run(el) {
      var to = +el.getAttribute('data-c'), suf = el.getAttribute('data-suf') || '';
      if (el.getAttribute('data-suf') === '-72h') { el.textContent = '24-72h'; return; }
      if (reduce) { el.textContent = to + suf; return; }
      var s = 0, step = to / 36;
      var t = setInterval(function () { s += step; if (s >= to) { s = to; clearInterval(t); } el.textContent = Math.round(s) + suf; }, 22);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    nums.forEach(function (el) { io.observe(el); });
  }

  function navScroll() {
    if (window.__tnNav) return; window.__tnNav = true;
    var on = false;
    function upd() {
      var s = window.scrollY > 50;
      if (s !== on) { on = s; document.documentElement.classList.toggle('tn-scrolled', on); }
    }
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  function init() {
    initBanners(); initVideoPosters(); initTrustStrip(); initStoreMap();
    injectTicker(); injectSeparators(); injectStats();
    initFutur(); navScroll();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', function () { setTimeout(init, 400); });
})();
